var Events = require('f.core.event');

var DataCenter = function (options) {
    this.cacheIds = [];
    this.lastT = null;
    this.options = options;
    this.timer = null;
    this.init();
};

DataCenter.prototype.init = function () {
    var _this = this;
    var id = this.options.id;
    var url = this.options.getUrl;
    $.ajax({
        url: url + id,
        type: 'get',
        dataType: 'jsonp',
        data: {
            format: 'jsonp'
        },
        success: function (msg) {
            if (typeof msg.code !== 'undefined' && msg.code !== 1) {
                return;
            }
            if (Array.isArray(msg)) {
                return;
            }
            //console.log("msg===",msg);
            var data = [];
            for (var key in msg) {
                data = data.concat(msg[key]);
            }
            //console.log(data);
            if (data.length > 0) {
                for (var i = 0; i < data.length; i++) {
                    data[i].avatar = data[i].avatar || '//p2.ifengimg.com/a/2018/0628/ifeng-logo.png'
                }
                data = _this.fliteById(data);
                chartList.add('danma', data);
            }
        }
    });
};

DataCenter.prototype.getData = function () {
    var id = this.options.id;
    var url = this.options.getUrl;
    var data = {
        format: 'jsonp'
    };
    if (this.lastT) {
        data.t = this.lastT - 1;
    }
    this.lastT = null;
    $.ajax({
        url: url + id,
        data: data,
        type: 'get',
        dataType: 'jsonp',
        success: function (msg) {
            this.lastT = msg.t;
            var data = msg.data;
            if (data.length > 0) {
                data = this.fliteById(data);
                this.trigger('data', data);
            }
        }.bind(this)
    });
};

var sendIndex = 0;
DataCenter.prototype.sendData = function (data) {
    var id = this.options.id;
    var url = this.options.sendUrl;
    var datainfo = {
        article_id: id,
        title: document.title.replace('凤凰', ''),
        url: window.location.href,
        content: data.val,
        fontsize: data.size,
        color: data.color,
        app: 'flash',
        type: 'realtime',
        format: 'jsonp'
    };
    $.ajax({
        url: url,
        type: 'get',
        dataType: 'jsonp',
        data: datainfo,
        success: function (msg) {
            data.id = 'sendBack_' + sendIndex++;
            this.trigger('send', [data]);
            // this.datas = this.datas.concat(msg)
        }.bind(this)
    });
};

DataCenter.prototype.fliteById = function (data) {
    var cacheIds = this.cacheIds;
    var result = [];
    var item;
    for (var i = 0, iLen = data.length; i < iLen; i++) {
        item = data[i];
        if (typeof cacheIds[item.id] == 'undefined') {
            cacheIds[item.id] = 1;
            result.push(item);
        }
    }
    return result;
};

DataCenter.prototype.start = function () {
    var intervalTime = this.options.interval || 5;
    clearInterval(this.timer);
    this.timer = setInterval(function () {
        this.getData();
    }.bind(this), intervalTime * 1000);
};

DataCenter.prototype.stop = function () {
    this.lastT = null;
    clearInterval(this.timer);
};

Events.mixTo(DataCenter);
module.exports = DataCenter;


// WEBPACK FOOTER //
// /Users/zhujian/Desktop/code/live_system/live/modules/f.compenont.barrage.pc/app/modules/dataCenter/live.js